module.exports = __webpack_public_path__ + "assets/cd09dc6d1f63a94579f3839a709335b3.png";